import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { NavLink, useHistory } from 'react-router-dom'
import Dashboard2 from 'custom/assets/common-icons/dashboard.svg'
import BackArrow from 'custom/assets/common-icons/back-arrow.svg'
import { MENU_DETAILS } from './menu-names-icons'
import { useTranslation } from 'react-i18next'
import { MENU_KEYS } from '../../utils/translation-constants'

export default function BreadCum({ pageTitle = '', breadCumKey }) {
  const history = useHistory()
  const parentMenuList = []
  const menuDetails = MENU_DETAILS.filter((ele) => ele.breadCumKey === breadCumKey)
  const breadCumDetails = menuDetails.length > 0 ? menuDetails[0] : []
  const { t } = useTranslation()
  return (
    <div className='header-title-section'>
      <div className='d-flex' style={{ alignItems: 'center' }}>
        <img
          className='mr-4 cursor-pointer'
          src={BackArrow}
          onClick={() => history.push('/dashboard')}
        />
        {menuDetails.length > 0 && (
          <>
            <img
              width={43}
              height={43}
              src={breadCumDetails?.parentIcon}
              style={{ marginRight: 15 }}
            />
            {breadCumDetails?.parent.map((option, index) => (
              <NavLink
                exact
                activeClassName={'active-menu-item'}
                className='bread-menu-item'
                key={index}
                to={option?.link}>
                {t(option?.title)}{' '}
              </NavLink>
            ))}
            {(breadCumKey !== 'BILLER_SERVICE_FORM' && breadCumKey !== 'ACCOUNTS_QUICK_PAY_SERVICE_FORM' && breadCumKey !== 'TRANSFERS_QUICK_PAY_SERVICE_FORM') && (
              <NavLink
                exact
                className='bread-menu-item'
                activeClassName={
                  breadCumDetails?.parent.length > 0 ? 'active-menu-item' : 'active-menu-item1'
                }
                to={breadCumDetails?.link}>
                {t(breadCumDetails?.title)}{' '}
              </NavLink>
            )}
            {(breadCumKey === 'BILLER_SERVICE_FORM' || breadCumKey === 'ACCOUNTS_QUICK_PAY_SERVICE_FORM' ||breadCumKey === 'TRANSFERS_QUICK_PAY_SERVICE_FORM') && (
              <NavLink
                exact
                className='bread-menu-item'
                activeClassName={
                  breadCumDetails?.parent.length > 0 ? 'active-menu-item' : 'active-menu-item1'
                }
                to={breadCumDetails?.link}>
                {pageTitle}{' '}
              </NavLink>
            )}
          </>
        )}
      </div>
      <div>
        {parentMenuList.length === 0 && (
          <div className='btn-dashboard' onClick={() => history.push('/dashboard')}>
            <img className='mr-2' width={18} height={18} src={Dashboard2} />
            {t(MENU_KEYS.DASHBOARD)}
          </div>
        )}

        {/* {parentMenuList.length > 0 && (
          <div className='parent-menus'>
            {parentMenuList.map((option, index) => (
              <OverlayTrigger
                placement={'bottom'}
                overlay={<Tooltip>{option.title}</Tooltip>}
                key={index}>
                <img
                  onClick={() => history.push(option?.link)}
                  width={25}
                  height={24}
                  src={option.icon}
                />
              </OverlayTrigger>
            ))}
          </div>
        )} */}
      </div>
    </div>
  )
}
